/**
 * @classdesc 配列系のユーティリティ クラス
 */
export default class ArrayUtils{

    /**
     * 配列をシャッフルする
     */
    static shuffleArray(array){

        for(let i=array.length-1; i>=0; i--){
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
          
        return array;
    }


    /**
     * Arrayから重複なく値を取り出す
     */
    static getRandomSelect(array, num){
        const a = array;
        const t = [];
        const r = [];
        let l = a.length;
        let n = num < l ? num : l;

        while(n-- > 0){
            let i = Math.random() * l | 0;
            r[n] = t[i] || a[i];
            --l;
            t[i] = t[l] || a[l];
        }

        return r;
    }


    /**
     * Arrayの中に重複するものがあるか
     * [ {key:value}, {key:value}]
     */
    static isSameElement(array){
        const keys = array.map(obj => obj.key);
        const uniqueKeys = new Set(keys);
        return keys.length !== uniqueKeys.size;
    }
}
